import type { JSONSchemaType } from 'ajv';

export type NotificationPermissionRequestSchema = null;

export const notificationPermissionRequestSchema: JSONSchemaType<NotificationPermissionRequestSchema> = {
  type: 'null',
  nullable: true,
}
